import { User } from '../Auth/Auth';
import { RoleTypes } from '../../helpers/RoleHelper';

export const DefaultUser = {
  id: '',
  userId: '',
  ttl: 0,
  first_name: '',
  last_name: '',
  created: '',
  driver: null
};

export interface DefaultAuthState {
  user: User;
  isLoggedIn: boolean;
  roles: Array<RoleTypes>;
  rolesLoaded: boolean;
  loading: boolean;
  error: any;
}

export const defaultAuthState: DefaultAuthState = {
  user: DefaultUser,
  isLoggedIn: false,
  roles: [],
  rolesLoaded: false,
  loading: false,
  error: null
};
